import React from 'react';
import { Link as ReactLink } from 'react-router-dom';

export default function Link({
  children,
  action = null,
  to = null,
  icon = null,
  isIconLeft = false,
  color = 'text-orange-500',
}) {
  return (
    <div data-component-name='Link'>
      {to && !action && (
        <ReactLink
          to={to}
          className={`${color} text-base sm:text-lg flex items-center gap-2.5 whitespace-nowrap`}
        >
          {icon !== null && isIconLeft === true && icon}
          {children}
          {icon !== null && isIconLeft === false && icon}
        </ReactLink>
      )}
      {action && !to && (
        <button
          type='button'
          onClick={() => action()}
          className={`${color} text-base sm:text-lg flex items-center gap-2.5 whitespace-nowrap`}
        >
          {icon !== null && isIconLeft === true && icon}
          {children}
          {icon !== null && isIconLeft === false && icon}
        </button>
      )}
    </div>
  );
}
